import { Tkv2PairedCostSummaryInterfaceV2 } from '../../types.ts';
import { AdjustmentBreakdownAdditionalStructure } from './AdjustmentBreakdownAdditionalStructure.tsx';

export const AdjustmentBreakdownAdditionalStructureWorkshop = (
  props: Tkv2PairedCostSummaryInterfaceV2,
) => (
  <AdjustmentBreakdownAdditionalStructure
    {...props}
    breakdownCategory="workshop"
    title="Workshop"
    id="isDepreciatedCostAdditionalImprovementsWorkshopInExport"
    summary={props}
  />
);
